import React from "react";

import { useDataList } from "@/lib/useData";

export function useScheduleType() {
  const [scheduleTypes, isLoading] = useDataList<{ id: number; name: string }>(
    process.env.NEXT_PUBLIC_API_URL + "/api/v1/enum/schedule_type",
  );

  const getScheduleTypeById = React.useCallback(
    (typeId: number) => {
      return scheduleTypes?.find(it2 => typeId === it2?.id);
    },
    [scheduleTypes],
  );

  return { getScheduleTypeById, scheduleTypes, isLoading };
}
